import { getUpsertCompanyEquityInformationDto } from '@bcba/validators';

const _GetUpsertCompanyEquityInformationDto =
  getUpsertCompanyEquityInformationDto();
export class UpsertCompanyEquityInformationDto extends _GetUpsertCompanyEquityInformationDto {}
